import type { IEventObject } from 'src/api/getEvents';
import type { ConnectorPlan } from '@weareopenr/types';

// A presigned S3 URL, so the global fetch: the wrapper's auth headers would invalidate the signature.
export const getPublishPlan = async ({ download_url }: IEventObject): Promise<ConnectorPlan> => {
  const res = await globalThis.fetch(download_url);
  if (!res.ok) {
    throw new Error(`Invalid status code returned: ${res.status}`);
  }
  return res.json();
};
